import script from "./pPopup.vue?vue&type=script&lang=ts&setup=true"
export * from "./pPopup.vue?vue&type=script&lang=ts&setup=true"

import "./pPopup.vue?vue&type=style&index=0&id=3c62150b&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c62150b"]])

export default __exports__